import { icon } from "#root/lib/dom";
export function dropdown(isMultiselect, placeholder, inactiveIcon, activePlaceholder, activeIcon, options, selectedOptions = [], onChange) {
  const dropdownContainer = document.createElement('div');
  dropdownContainer.classList.add('dropdown-container');
  dropdownContainer.addEventListener('keydown', event => {
    if (event.key === 'Enter') {
      setActive();
    }
  });
  const hitBox = document.createElement('div');
  hitBox.classList.add('dropdown-hit-box');
  hitBox.tabIndex = 0;
  dropdownContainer.appendChild(hitBox);
  const hitBoxContent = document.createElement('div');
  hitBoxContent.classList.add('dropdown-hit-box-content');
  hitBoxContent.innerText = placeholder;
  hitBox.appendChild(hitBoxContent);
  const iconContainer = document.createElement('div');
  iconContainer.classList.add('icon-container');
  hitBox.appendChild(iconContainer);
  const inactiveIconElement = icon(inactiveIcon);
  inactiveIconElement.classList.add('inactive-icon');
  iconContainer.appendChild(inactiveIconElement);
  const activeIconElement = icon(activeIcon);
  activeIconElement.classList.add('active-icon');
  iconContainer.appendChild(activeIconElement);
  let filter = '';
  let focusOption = null;
  let focusOptionIndex = null;
  let currentList = null;
  let currentDropdown = null;
  let clickBlurPlanned = false;
  let listElement = null;

  function setFocus(index, scrollIntoView = true) {
    const {
      option,
      element
    } = currentList[index];
    focusOption = {
      option,
      element
    };
    focusOptionIndex = index;

    for (const option of currentList) {
      option.element.classList.remove('focus');
    }

    element.classList.add('focus');
    if (scrollIntoView) element.scrollIntoView({
      block: 'nearest'
    });
  }

  let lastScrollPosition; //let needsRefocus = false;

  function pick(option) {
    if (!("value" in option)) {
      for (var i = selectedOptions.length - 1; i >= 0; i--) {
        selectedOptions.splice(i, 1);
      }

      onChange(selectedOptions);
    } else {
      var hasOption = selectedOptions.findIndex(selectedOption => selectedOption.value === option.value);

      if (hasOption !== -1) {
        selectedOptions.splice(hasOption, 1);
      } else {
        selectedOptions.push(option);
      }

      onChange(selectedOptions);
    }

    if (!isMultiselect) {
      lastScrollPosition = undefined;
    } else {//needsRefocus = true;
    }

    if (!isMultiselect) {
      setTimeout(() => {
        setInactive();
      }, 0);
    } else {
      setTimeout(() => {
        setInactive();
        setActive(false);
        listElement.querySelector('.scroll-sliver').scrollTop = lastScrollPosition;
      }, 0);
    }
  }

  function repositionDropdown() {
    const rect = hitBox.getBoundingClientRect();
    listElement.style.width = `${rect.width}px`;
    listElement.style.left = `${rect.left}px`;
    listElement.style.top = `${rect.bottom}px`;
  }

  let hitBoxInput = null;

  function setActive(scrollIntoView = true) {
    clickBlurPlanned = false;
    dropdownContainer.classList.add('active');
    hitBoxContent.innerHTML = '';
    hitBoxInput = document.createElement('input');
    hitBoxInput.classList.add('dropdown-input');
    hitBoxInput.type = 'text';
    hitBoxInput.placeholder = activePlaceholder;
    hitBoxInput.addEventListener('input', event => {
      filter = event.target.value;
      generateList(scrollIntoView);
    });
    hitBoxInput.addEventListener('blur', function () {
      if (clickBlurPlanned) {
        clickBlurPlanned = false;
        return;
      }

      setInactive();
    });
    hitBoxInput.addEventListener('keydown', event => {
      if (event.key === 'Enter' && focusOption) {
        event.preventDefault();
        pick(focusOption.option);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();

        if (focusOptionIndex < currentList.length - 1) {
          setFocus(focusOptionIndex + 1);
        }
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();

        if (focusOptionIndex > 0) {
          setFocus(focusOptionIndex - 1);
        }
      } else if (event.key === 'Escape') {
        event.preventDefault();
        setInactive();
      }
    });
    hitBoxContent.appendChild(hitBoxInput);
    hitBoxInput.focus();
    generateList(scrollIntoView);
    document.addEventListener('scroll', repositionDropdown, true);
    window.addEventListener('resize', repositionDropdown, true);
  }

  hitBox.addEventListener('click', () => setActive());

  function setInactive() {
    hitBoxInput = null;
    dropdownContainer.classList.remove('active');
    hitBoxContent.innerHTML = '';
    hitBoxContent.innerText = selectedOptions && selectedOptions.length > 0 ? selectedOptions.map(e => e.label).join(", ") : placeholder;

    if (selectedOptions && selectedOptions.length > 0) {
      hitBoxContent.classList.add('selected');
    } else {
      hitBoxContent.classList.remove('selected');
    }

    document.removeEventListener('scroll', repositionDropdown, true);
    window.removeEventListener('resize', repositionDropdown, true);
    focusOption = null;
    focusOptionIndex = null;
    filter = '';
    currentList = null;

    if (currentDropdown) {
      currentDropdown.remove();
    }

    currentDropdown = null;
    listElement = null;
    hitBox.focus();
  }

  function generateList(scrollIntoView = true) {
    if (currentDropdown) {
      currentDropdown.remove();
    }

    const list = document.createElement('div');
    listElement = list;
    currentDropdown = list;
    list.classList.add('overlay-dropdown-list');
    document.body.appendChild(list);
    list.addEventListener('mousedown', e => {
      e.preventDefault();
    });
    repositionDropdown();
    const positionSliver = document.createElement('div');
    positionSliver.classList.add('position-sliver');
    list.appendChild(positionSliver);
    const scrollSliver = document.createElement('div');
    scrollSliver.classList.add('scroll-sliver');
    scrollSliver.addEventListener('scroll', () => {
      lastScrollPosition = scrollSliver.scrollTop;
    });
    positionSliver.appendChild(scrollSliver);
    currentList = [];
    const resetOption = {
      label: 'Скинути'
    };
    const iterateOptions = selectedOptions && selectedOptions.length > 0 ? [resetOption, ...options] : options;

    for (const option of iterateOptions) {
      if (filter !== '' && !option.label.toLowerCase().includes(filter.toLowerCase())) {
        continue;
      }

      if (filter !== '' && !("value" in option)) {
        continue;
      }

      const optionElement = document.createElement('div');
      optionElement.classList.add('dropdown-option');
      optionElement.innerText = option.label;
      optionElement.tabIndex = 0;
      scrollSliver.appendChild(optionElement);

      if (!("value" in option)) {
        optionElement.classList.add('reset');
      } else {
        if (selectedOptions && selectedOptions.length > 0 && selectedOptions.findIndex(selectedOption => selectedOption.value === option.value) !== -1) {
          optionElement.classList.add('selected');
        }
      }

      currentList.push({
        option: option,
        element: optionElement
      });
      optionElement.addEventListener('mousedown', () => {
        clickBlurPlanned = true;
        pick(option);
      });
      optionElement.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          pick(option);
        }
      });
    }

    if (currentList.length > 0) {
      if (selectedOptions && selectedOptions.length > 0) {
        let lastSelectedOption = selectedOptions[selectedOptions.length - 1];
        setFocus(iterateOptions.findIndex(option => option.value === lastSelectedOption.value), scrollIntoView);
      } else {
        setFocus(0, scrollIntoView);
      }
    }
  }
  /*dropdownContainer.refocus = () => {
      if (needsRefocus) {
          needsRefocus = false;
      } else {
          return;
      }
       if (hitBoxInput) hitBoxInput.focus();
      if (isMultiselect) {
          setActive(false);
          if (lastScrollPosition !== undefined) listElement.querySelector('.scroll-sliver').scrollTop = lastScrollPosition;
      }
  }*/


  setInactive();
  return dropdownContainer;
}